'use client'

import React from 'react'
import { Card } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Users, Medal, TrendUp, Sparkle } from 'phosphor-react'
import Components from '../components'

export default function ProfessionalProjects() {
  return (
    <Components.PageContainer>
      <Components.SkipLink />
      <Components.GlassNavigation />
      
      <main id="main-content" tabIndex={-1} className="pt-16 md:pt-32 pb-16 px-4 md:px-6" role="main" aria-label="Professional projects">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-16">
            <h1 className="text-2xl md:text-3xl lg:text-5xl font-bold text-[var(--brutal-ink)] mb-4 md:mb-6 leading-tight break-words px-4">
              Creative Leadership for<br />Meaningful Change
            </h1>
            <p className="text-base md:text-lg lg:text-xl text-[var(--brutal-muted)] max-w-4xl mx-auto leading-relaxed break-words px-4">
              I transform complex enterprise challenges into experiences that drive measurable business impact
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-16 max-w-6xl mx-auto">
            <Card className="brutal-panel p-4 md:p-8 text-center hover:bg-[var(--brutal-kraft)] transition-all duration-300">
              <Users weight="duotone" className="w-6 h-6 md:w-10 md:h-10 text-[var(--brutal-accent)] mx-auto mb-2 md:mb-6 flex-shrink-0" aria-hidden="true" />
              <div className="text-2xl md:text-4xl font-bold text-[var(--brutal-ink)] mb-1 md:mb-3 break-words">8+</div>
              <div className="text-[var(--brutal-muted)] text-xs md:text-base break-words">Teams Led</div>
            </Card>
            
            <Card className="brutal-panel p-4 md:p-8 text-center hover:bg-[var(--brutal-kraft)] transition-all duration-300">
              <Medal weight="duotone" className="w-6 h-6 md:w-10 md:h-10 text-[var(--brutal-ink)] mx-auto mb-2 md:mb-6 flex-shrink-0" aria-hidden="true" />
              <div className="text-2xl md:text-4xl font-bold text-[var(--brutal-ink)] mb-1 md:mb-3 break-words">50+</div>
              <div className="text-[var(--brutal-muted)] text-xs md:text-base break-words">Projects Delivered</div>
            </Card>
            
            <Card className="brutal-panel p-4 md:p-8 text-center hover:bg-[var(--brutal-kraft)] transition-all duration-300">
              <TrendUp weight="duotone" className="w-6 h-6 md:w-10 md:h-10 text-[var(--brutal-accent)] mx-auto mb-2 md:mb-6 flex-shrink-0" aria-hidden="true" />
              <div className="text-2xl md:text-4xl font-bold text-[var(--brutal-ink)] mb-1 md:mb-3 break-words">$25M+</div>
              <div className="text-[var(--brutal-muted)] text-xs md:text-base break-words">Revenue Impact</div>
            </Card>
            
            <Card className="brutal-panel p-4 md:p-8 text-center hover:bg-[var(--brutal-kraft)] transition-all duration-300">
              <Sparkle weight="duotone" className="w-6 h-6 md:w-10 md:h-10 text-[var(--brutal-accent)] mx-auto mb-2 md:mb-6 flex-shrink-0" aria-hidden="true" />
              <div className="text-2xl md:text-4xl font-bold text-[var(--brutal-ink)] mb-1 md:mb-3 break-words">12+</div>
              <div className="text-[var(--brutal-muted)] text-xs md:text-base break-words">Years Experience</div>
            </Card>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Components.ProjectCard
              title="PromoAI Enterprise Planning App"
              description="Founded Cognira's first in-house Product Design & UX practice for PromoAI SaaS solution with human-centered design"
              duration="18 months"
              role="Director of UX"
              tags={['UX Research', 'SaaS Platform', 'Practice Building']}
              link="/PromoAI"
              image="assets/promoAI-card.png"
            />
            
            <Components.ProjectCard
              title="PromoUI Design System"
              description="Comprehensive design system and UI component library built with Storybook, reducing regression bugs by 44%"
              duration="12 months"
              role="Product Manager"
              tags={['Design Systems', 'Component Library', 'Storybook']}
              link="/PromoUI"
              image="assets/promoUI-design-system-card.png"
            />
            
            <Components.ProjectCard
              title="Store Inventory Operations"
              description="Mobile application for store operations and inventory management with cross-product UX unification"
              duration="15 months"
              role="Senior UX Designer"
              tags={['Mobile Design', 'Store Operations', 'Inventory']}
              link="/StoreInventoryOperations"
              image="assets/siocs-card.png"
            />
            
            <Components.ProjectCard
              title="AI Agent - Retail Promotion Planning"
              description="Agentic AI UX vision for forecasting and predictive AI products, transforming complex retail promotion workflows"
              duration="8 months"
              role="Director of UX"
              tags={['AI/ML Design', 'Retail Planning', 'Predictive Analytics']}
              link="/AIAgentCaseStudy"
              image="assets/ai-agent-card.png"
            />
            
            <Components.ProjectCard
              title="Supply Chain Optimization"
              description="Rule-engine app for automated supply chain management with Oracle Redwood design system implementation"
              duration="24 months"
              role="Strategy & Design Lead"
              tags={['Rule Engine', 'Oracle Redwood', 'Strategic Leadership']}
              link="/SupplyChainOptimization"
              image="assets/supply-chain-optimization-card.png"
            />
            
            <Components.ProjectCard
              title="Design Mentorship"
              description="Mentoring Product Leads, Product Managers, and interns on design thinking, discovery, and data-driven roadmapping"
              duration="Ongoing"
              role="Mentor & Educator"
              tags={['Mentorship', 'Design Thinking', 'Leadership']}
              link="/DesignMentorship"
              image="assets/design-mentorship-card.png"
            />
          </div>
        </div>
      </main>
    </Components.PageContainer>
  )
}

